import { GetServerSidePropsContext } from "next";
import Home from "views/index";
import { AppWithTrans } from "ez-i18next";
import Fetcher, { getCountryInfo } from "server/fetcher";
import {
	GetFrontPlayground,
	GetFrontPlaygroundResp,
	GetFrontModules,
	GetFrontModulesResp,
	GetFrontPlaygroundReq,
} from "services/page/app";
import { updateStore } from "ssrcontext";
import { reconstructFrontMods } from "utils/playground/module";
import { parseProductTagFromUrl } from "utils/playground/url";
import { IncomingMessage } from "http";
import { isNotBlankArray } from "utils/array";
import { RuntimeProps } from "../../../src/views/index";
import { transformMetaForApi } from "utils/playground";

type IncomingMessagePro = IncomingMessage & {
	cookies: { [key: string]: string };
	runtime: RuntimeProps;
};
export interface GetServerSidePropsContextPro extends GetServerSidePropsContext {
	req: IncomingMessagePro;
}

export const getServerSideProps = async ({ req, query }: GetServerSidePropsContextPro) => {
	let { runtime } = req;
	const {
		platform,
		languageCode: language,
		currency,
		hostname,
		api,
		userAgent,
		href,
		search,
		isUat,
		countryKey,
		sid,
	} = runtime;
	const { countryCode2, countryCode3, countryId } = await getCountryInfo(countryKey, { sid, language, currency });

	const fetcher = new Fetcher({
		platform,
		uat: isUat,
		country: countryCode3,
		req,
		api,
		hostname,
		language,
	});
	runtime = {
		...runtime,
		countryCode3,
		countryCode2,
		countryId
	};
	const meta = transformMetaForApi(runtime);
	const id: string = query.pageId as string;
	const version: string = (query.version as string) || "";
	const tag: string = (query.tag as string) || "";
	const { pageName } = await fetcher.getFSeoInfo(id);

	let playgroundProps: Partial<GetFrontPlaygroundReq> = {
		id,
		meta,
	};
	if (version) {
		playgroundProps = {
			...playgroundProps,
			version,
		};
	}
	let playgroundData: GetFrontPlaygroundResp = await GetFrontPlayground(playgroundProps, {
		meta: fetcher.metaDataValues,
	});

	const tagQuery = parseProductTagFromUrl(tag || "");
	let frontMods: any = [];
	if (isNotBlankArray(playgroundData?.modules)) {
		const moduleId: string[] = [
			...playgroundData.modules
				.filter((item) => item.header?.position)
				.map((item) => item.id),
		];
		let modRes: GetFrontModulesResp = await GetFrontModules(
			{
				moduleId,
				meta,
			},
			{
				meta: fetcher.metaDataValues,
				baseInfo: {
					onlyFetch: true,
					platform: playgroundData.page?.catalog,
					isuat: isUat,
					hostname,
				},
			},
		);
		frontMods = modRes?.mods
			? await reconstructFrontMods({
					mods: modRes.mods,
					meta,
					metaData: fetcher.metaDataValues,
					tagQuery,
					runtime: runtime as RuntimeProps,
			  })
			: {};
	}

	updateStore({
		// 覆盖constants 内的属性
		countryCode: "LITB",
		languageCode: language,
		currencyCode: currency,
		platform,
		meta: fetcher.metaDataValues,
		// Api请求和环境判断使用
		api,
		hostname,
		userAgent,
		id,
		href,
		search,
		origin: hostname,
		isUat,
		cookies: req.headers.cookie || "",
	});
	const localeObj = await require("server/i18nStore").Store.getLocaleObj(["index"], language);
	return {
		props: {
			...playgroundData,
			frontModules: frontMods ? Object.values(frontMods) : [],
			runtime,
			localeObj,
			tagQuery,
			title: pageName || playgroundData?.page?.name || "",
		},
	};
};

export default AppWithTrans(Home);
